import PropTypes from "prop-types";
import Circle from "./components/Circle";
import styles from "./FormPercentageCircle.module.scss";
import SelectionStatsIcon from "../../assets/icons/selection_stats.svg";

const FormPercentageCircle = ({ probability }) => {
  return (
    <div className={styles.formPercentageCircle}>
      <svg
        data-testid="form-percentage-circle"
        height="44px"
        width="44px"
        viewBox="0 0 44 44"
      >
        <Circle color="#009745" percentage={probability} fill="#ffffff" />
        <image height={12} width={12} xlinkHref={SelectionStatsIcon} />
        <text
          dominantBaseline="central"
          textAnchor="middle"
          fontSize={12}
          fontWeight="bold"
        >
          {probability.toFixed(0)}%
        </text>
      </svg>
    </div>
  );
};

FormPercentageCircle.propTypes = {
  probability: PropTypes.number,
};

export default FormPercentageCircle;
